import { CommonService } from 'app/services/common.service';
import { ClassBaseService } from './../../services/class-base.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-parent-message-tabs',
  templateUrl: './parent-message-tabs.component.html',
  styleUrls: ['./parent-message-tabs.component.scss']
})
export class ParentMessageTabsComponent implements OnInit, OnChanges {

  @Input() messageData: any;

  parentTopicList = [];
  parentTopic = '0';
  firstTabMessageData: any;

  constructor (
    private notificationService : NotificationService,
    private _classBaseService: ClassBaseService,
    private _commonService: CommonService
  ) { }

  ngOnInit() {
    const parentMessageTabsData = this._commonService.getParentMessageTabsData();
    if (parentMessageTabsData && parentMessageTabsData.studentData) {
      this.firstTabMessageData = parentMessageTabsData.studentData.studentName;
    }
    this.getParentTopicList();
  }

  ngOnChanges() {
    if (this.messageData) {
      this.firstTabMessageData = this.messageData.name;
    }
  }

  getParentTopicList() {
    this._classBaseService.getMessageTopicList()
      .subscribe(
      (dataList: any) => {
        this.parentTopicList = dataList;
      },
      () => {
        this.notificationService.show('error', 'Error while fetching topic list data');
      });
  }

}
